const initialState = {
    chosenExtraFeatures: [],
    hasChosenExtraFeatures: false,
};

export const PossibleFeatures = {
    reservePrice: 'reservePrice',
    highlight: 'highlight',
    rankUp: 'rankUp',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CHOSEN_EXTRA_FEATURES': {
            const hasChosenExtraFeatures =
                action.payload && action.payload.length > 0;
            return {
                ...state,
                chosenExtraFeatures: action.payload,
                hasChosenExtraFeatures,
            };
        }
    }

    return state;
};
